import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

/**
 * Mutation hook for `DELETE /v1/clients/{id}`. Invalidates the
 * `['clients']` list and removes the `['clients', id]` detail entry on
 * success so the SPA doesn't keep a stale row around.
 *
 * Casbin gates `(client, delete)` on the server — Admin only. Operator
 * + Viewer get 403.
 */
export function useDeleteClientMutation(): UseMutationResult<void, Error, string> {
  const api = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => {
      if (!api) {
        throw new Error('useDeleteClientMutation: api client unavailable (no signed-in account)');
      }
      return api.delete<void>(`/v1/clients/${id}`);
    },
    onSuccess: (_data, id) => {
      void queryClient.invalidateQueries({ queryKey: ['clients'] });
      queryClient.removeQueries({ queryKey: ['clients', id] });
    },
  });
}
